'use strict'

var objectToString = Object.prototype.toString

module.exports = function(v){
    return !!v && objectToString.call(v) === '[object Object]'
}




//////////////////
// WEBPACK FOOTER
// ./node_modules/to-style/src/isObject.js
// module id = 893
// module chunks = 0